import { Map } from 'immutable';

import { createPaginatedListSelector } from 'app/selectors';

export const couponList = createPaginatedListSelector((state) =>
  state.coupons.get('couponList', Map()),
);
